import { render, staticRenderFns } from "./ModalConfirm.vue?vue&type=template&id=325cb04e&"
import script from "./ModalConfirm.vue?vue&type=script&lang=ts&"
export * from "./ModalConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports